import axios from 'axios';

const postToLinkedIn = async (content, accessToken, userId) => {
  try {
    await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/linkedin/post-text`, {
      accessToken,
      userId,
      text:content,
    });
  } catch (error) {
    console.error('Error posting to LinkedIn:', error);
    throw error;
  }
};

export default postToLinkedIn;
